<template>
    <vue-custom-scrollbar class="lite-lower-result-materials">
        <div v-if="productsCost.length === 0" class="no-materials-text">
            <img :src="urlForStatic('/img/select_plane_tip.png')" alt="tooltip-img" class="lite-lower-result-tooltip-img">
            <div class="lite-lower-result-tooltip-text-container">
                <div class="lite-lower-result-tooltip-text">
                    Материалы пока не добавлены.
                    <span class="red-text">Выберите участок</span>
                    здания и примените к нему
                    <span class="red-text">материал из каталога</span>
                </div>
            </div>
        </div>
        <div v-else class="lite-lower-result-grid" v-for="element in productsCost">
            <div class="flex-center lite-lower-result-grid-el">
                <img :src="urlForPhoto(element.src)" :alt="element.name" class="lite-lower-result-img">
            </div>
            <div class="lite-lower-result-grid-el">
                {{element.name}}
            </div>
            <div class="text-center lite-lower-result-grid-el">
                {{getName(element.type)}}
            </div>
        </div>
    </vue-custom-scrollbar>
</template>

<script>
import vueCustomScrollbar from 'vue-custom-scrollbar';
import {urlForStaticVue} from "../common";

export default {
    name: "ResultMaterialsCard",
    components: {
        vueCustomScrollbar
    },
    mixins: [urlForStaticVue],
    props: [
        'designId',
        'designMaterialChanged'
    ],
    data() {
        return {
            names: {
                wall: 'Фасад',
                additional: 'Доборный элемент',
                platband: 'Наличник'
            }
        }
    },
    computed:{
        productsCost() {
            return this.$store.getters["costLite/PRODUCTS_COST"];
        },
        photos(){
            return this.$store.getters["active/GET_ALL_PHOTO"];
        },

    },
    watch: {
        designMaterialChanged() {
            this.getResult()
        },
        designId() {
            this.getResult()
        }
    },
    methods: {
        urlForPhoto(url) {
            return this.$store.getters[`projectConfiguration/GENERATE_URL`](url);
        },
        getName(value) {
            return this.names[value]
        },
        getResult() {
            this.$store.dispatch('resultImg/GET_DESIGN_PHOTO', {
                designID: this.idDesign,
                photoID: Object.keys(this.photos)[0]
            });
            this.$store.dispatch('costLite/GET_COST');
        }
    },
    mounted() {
        if (this.designId) {
            this.getResult()
        }
    },
}
</script>

<style scoped>
    .text-center {
        text-align: center;
    }
    .no-materials-text {
        width: 100%;
        height: 100%;
        display: flex;
        justify-content: center;
        align-items: center;
        flex-direction: column;
    }
    .lite-lower-result-tooltip-img {
        height: 30vh;
        width: 25vw;
        object-fit: contain;
        padding: 10px;
        box-sizing: border-box;
    }
    .lite-lower-result-tooltip-text-container {
        height: 10vh;
        padding: 10px;
        display: flex;
        justify-content: center;
        align-items: center;
        box-sizing: border-box;
    }
    .lite-lower-result-tooltip-text {
        text-align: center;
        font-size: 14px;
    }
    .lite-lower-result-grid-el {
        padding: 0 5px;
        text-overflow: ellipsis;
        overflow: hidden;
    }
    .lite-lower-result-materials {
        padding: 10px;
        width: 30vw;
        height: 40vh;
        box-sizing: border-box;
        background-color: white;
        border: 1px solid #ededed;
        overflow: hidden;
        /*overflow-y: auto;*/
        border-radius: 5px;
        box-shadow: 0 0.6rem 1.1rem rgba(0, 0, 0, 0.15);
    }

    .lite-lower-result-grid {
        display: grid;
        grid-template-columns: 30% 48% 18%;
        grid-column-gap: 2%;
        margin-bottom: 10px;
        transition: all 0.3s ease;
        padding: 10px;
        box-sizing: border-box;
        border-radius: 5px;
    }

    .lite-lower-result-grid:hover {
        background-color: #f6f6f6;
        box-shadow: 0 0.6rem 1.1rem rgba(0, 0, 0, 0.15);
    }

    .lite-lower-result-img {
        width: 100%;
        height: 100px;
        border-radius: 5px;
        object-fit: cover;
    }
</style>
